import { useState } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/format";
import { toast } from "sonner";

const INF = <span style={{ fontSize: "1.6em", lineHeight: 1, verticalAlign: "-0.15em" }}>∞</span>;

export function BagAmount({ amount, isGod }) {
  return isGod ? INF : (amount ?? 0);
}

export function ShopBuy() {
  const { user } = useAuth();
  const [qty, setQty] = useState("");
  const [busy, setBusy] = useState(false);
  const n = Number(qty);
  const valid = Number.isInteger(n) && n >= 1 && n <= 10000;

  if (user?.is_guest) return <p className="text-sm py-4" style={{ color: "var(--text-muted)" }} data-testid="shop-guest">sign in to buy provisions</p>;
  if (user?.is_god) return <p className="text-sm py-4" style={{ color: "var(--accent)" }} data-testid="shop-god">you hold infinite provisions</p>;

  const buy = async () => {
    if (!valid || busy) return;
    setBusy(true);
    try {
      const { data } = await api.post("/payments/checkout", { quantity: n, origin_url: window.location.origin });
      window.location.href = data.checkout_url;
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
      setBusy(false);
    }
  };

  return (
    <div>
      <p className="text-xs tracking-widest mb-6" style={{ color: "var(--text-muted)" }} data-testid="shop-balance">
        your bag · {user?.provisions ?? 0} provisions
      </p>
      <label className="text-xs uppercase tracking-widest" style={{ color: "var(--text-muted)" }}>how many provisions</label>
      <input
        data-testid="shop-quantity-input"
        type="number"
        min={1}
        max={10000}
        value={qty}
        onChange={(e) => setQty(e.target.value.replace(/[^0-9]/g, ""))}
        onKeyDown={(e) => { if (e.key === "Enter") buy(); }}
        placeholder="1"
        className="w-full px-4 py-3 mt-2"
        style={{ background: "transparent", border: "1px solid var(--border)", color: "var(--text-primary)" }}
      />
      <p className="text-xs mt-2" style={{ color: "var(--text-muted)" }}>1 provision = 1 CAD · + 10% commission</p>
      <div className="mt-6 flex flex-col gap-1 text-xs tracking-widest" style={{ color: "var(--text-muted)" }}>
        <span data-testid="shop-subtotal">provisions · ${valid ? n.toFixed(2) : "0.00"}</span>
        <span data-testid="shop-commission">commission (10%) · ${valid ? (n * 0.1).toFixed(2) : "0.00"}</span>
      </div>
      <p className="font-head text-xl mt-3" style={{ color: "var(--text-primary)" }} data-testid="shop-total">
        total · ${valid ? (n * 1.1).toFixed(2) : "0.00"} CAD
      </p>
      <button onClick={buy} disabled={!valid || busy} data-testid="shop-buy-btn" className="btn w-full py-3 mt-6 text-sm tracking-widest">
        {busy ? "…" : "BUY"}
      </button>
    </div>
  );
}

export function BagButton({ amount, isGod, testId = "bag-btn", className = "" }) {
  return (
    <span data-testid={testId} className={`inline-block text-xs tracking-widest px-4 py-2 ${className}`} style={{ border: "1px solid var(--border)", color: "var(--text-primary)" }}>
      PROVISIONS · <BagAmount amount={amount} isGod={isGod} />
    </span>
  );
}
